import React from "react";
import "./pageheader.css";

function PageHeader({ title }) {
  return (
    <div className="page-header">
      <h1 className="page-title">{title}</h1>
      <p className="page-breadcrumb">Home / {title}</p>
    </div>
  );
}

export default PageHeader;
